import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AboutUs() {
  return (
    <div className="flex flex-col gap-16">
      <Header />
      <div className="px-4 py-16 bg-gray-50">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-5xl font-extrabold text-blue-950 mb-10">
            About Us
          </h2>

          {/* Company Overview Section */}
          <div className="text-left space-y-8">
            <p className="text-xl text-gray-700">
              Welcome to <span className="font-semibold text-blue-700">Edgecore Technologies</span>, your trusted partner in IT recruitment services. We specialize in bridging the gap between exceptional IT talent and forward-thinking organizations. With a proven track record of delivering tailored recruitment solutions, we help businesses thrive by connecting them with the right professionals for their unique needs.
            </p>
          </div>

          {/* Who We Are Section */}
          <div className="flex flex-col md:flex-row gap-12 mt-16">
            <div className="flex flex-col justify-center md:w-1/2">
              <h3 className="text-3xl font-semibold text-blue-950">
                Who We Are
              </h3>
              <p className="text-lg text-gray-700 mt-4">
              Edgecore Technologies is a team of passionate recruitment specialists with deep expertise in the IT industry. Our journey began with a vision to simplify and enhance the hiring process for both employers and job seekers. Over the years, we have established ourselves as a reliable and innovative recruitment partner, catering to a diverse range of IT roles and industries.
              </p>
            </div>
            <div className="md:w-1/2">
              <img
                src="https://images.pexels.com/photos/3184436/pexels-photo-3184436.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                alt="About Us"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
          </div>

          {/* Our Mission Section */}
          <div className="text-left mt-16">
            <h3 className="text-3xl font-semibold text-blue-950">
              Our Mission
            </h3>
            <p className="text-lg text-gray-700 mt-4">
              Our mission is to empower organizations by providing access to top-tier IT talent while enabling professionals to find fulfilling career opportunities. We aim to create a seamless recruitment experience that fosters growth, innovation, and success for all stakeholders.
            </p>
          </div>

          {/* What We Offer Section */}
          <div className="mt-16 text-left">
            <h3 className="text-3xl font-semibold text-blue-950">
              What We Offer
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
              {/* For Employers */}
              <div>
                <h4 className="text-2xl font-semibold text-blue-950">
                  For Employers:
                </h4>
                <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
                  <li>Customized Recruitment Solutions tailored to your needs.</li>
                  <li>Access to a vast talent pool of highly skilled IT professionals.</li>
                  <li>Efficient hiring process to save you time and resources.</li>
                  <li>Flexible hiring options including permanent and contract roles.</li>
                </ul>
              </div>

              {/* For Job Seekers */}
              <div>
                <h4 className="text-2xl font-semibold text-blue-950">
                  For Job Seekers:
                </h4>
                <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
                  <li>Exclusive access to career opportunities with leading organizations.</li>
                  <li>Personalized job search support and career guidance.</li>
                  <li>Skill matching to ensure the right fit between your expertise and job roles.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Why Choose Us Section */}
          <div className="mt-16 text-left">
            <h3 className="text-3xl font-semibold text-blue-950">
              Why Choose Us?
            </h3>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>Industry expertise in IT trends and requirements.</li>
              <li>A proven track record of successful placements across various IT domains.</li>
              <li>Tech-driven approach to recruitment using modern tools and technologies.</li>
              <li>Commitment to excellence, always achieving the highest standards of service.</li>
            </ul>
          </div>

          {/* Our Values Section */}
          <div className="mt-16 text-left">
            <h3 className="text-3xl font-semibold text-blue-950">
              Our Values
            </h3>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li><strong>Integrity</strong>: Building trust through transparency and ethical practices.</li>
              <li><strong>Excellence</strong>: Striving for perfection in every aspect of our work.</li>
              <li><strong>Innovation</strong>: Staying ahead with modern recruitment practices.</li>
              <li><strong>Diversity and Inclusion</strong>: Promoting a culture that values diverse perspectives.</li>
            </ul>
          </div>

          {/* Conclusion Section */}
          <div className="mt-16 text-center">
            <h3 className="text-2xl font-semibold text-blue-950">
              Let’s Build the Future Together
            </h3>
            <p className="text-lg text-gray-700 mt-4">
              At <span className="font-semibold text-blue-700">Edgecore Technologies</span>, we don’t just fill positions—we build careers and help organizations grow. Whether you’re an employer looking for the perfect candidate or a professional seeking your next big opportunity, we are here to make it happen.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutUs;
